import {LitElement, html, nothing} from "lit";
import {customElement, property, state, query} from "lit/decorators.js";
import {classMap} from "lit/directives/class-map.js";

import {collapsibleSectionStyles} from "./CollapsibleSection.styles.js";

@customElement("pn-collapsible-section")
export class CollapsibleSection extends LitElement {
	static styles = [collapsibleSectionStyles];

	@property() className:       string;
	@property() iconMask = false;
	@property() id:              string;
	@property() isOpenInitially = true;
	@property() onClickCallback: (section: HTMLElement) => void;
	@property() showBadge = false;
	@property() showCaret = true;
	@property() title:           string;

	@state() isOpen: boolean;

	@query(".collapsible-section") _collapsibleSection: HTMLElement;

	firstUpdated() {
		// TODO: not sure if this is the best place to put this
		this.isOpen = this.isOpenInitially;
	}

	handleToggleCollapse = () => {
		this.isOpen = !this.isOpen;
		const section = this._collapsibleSection;

		// TODO: test
		if (this.onClickCallback)
			this.onClickCallback(section);
	};

	render() {
		return html`
			<div
				class=${classMap({
					"collapsible-section":  true,
					"dotted-focus-outline": true,
					[this.className]:       this.className,
					"show-badge":           this.showBadge,
					"open":                 this.isOpen
				})}
				id="${this.id ?? nothing}"
			>
				<h2>
					<button
						class="btn-toggle dotted-focus-outline"
						@click="${this.handleToggleCollapse}"
						type="button"
					>
						${this.showCaret
							? html`
								<i
									class="${classMap({
										"icon-chevron-light-right": true,
										"icon-mask":                this.iconMask
									})}"
								></i>
							`
							: nothing
						}
						<span class="title">
							<span class="title-text">${this.title}</span>
							<span class="badget"></span>
						</span>
					</button>
				</h2>
				<div class="section-content">
					<slot></slot>
				</div>
			</div>
		`;
	}
};

declare global {
	interface HTMLElementTagNameMap {
		"pn-collapsible-section": CollapsibleSection;
	}
}
